// src/Dashboard/pages/user/DashboardUser/components/DashboardUserModuleNav.jsx

import React from "react";
import { formatBadge } from "../utils/dashboardUserUtils";

function Badge({ value, tone = "violet" }) {
  const label = formatBadge(value);
  if (!label) return null;

  const toneMap = {
    violet: "bg-violet-600",
    amber: "bg-amber-500",
    sky: "bg-sky-600",
    rose: "bg-rose-600",
    slate: "bg-slate-600",
    emerald: "bg-emerald-600",
  };

  return (
    <span
      className={`inline-flex min-w-5 items-center justify-center rounded-full px-1.5 py-0.5 text-[10px] font-bold leading-none text-white ${
        toneMap[tone] || toneMap.violet
      }`}
    >
      {label}
    </span>
  );
}

function ModuleButton({ item, active, onClick }) {
  const Icon = item.icon;

  return (
    <button
      type="button"
      onClick={onClick}
      className={[
        "group flex w-full items-center gap-3 rounded-2xl px-3 py-3 text-left text-sm ring-1 transition",
        active
          ? "bg-gradient-to-r from-[#013E8E] via-indigo-600 to-[#0f5cc0] text-white ring-transparent shadow-md"
          : item.attention
          ? "bg-amber-50 text-slate-800 ring-amber-200 hover:bg-amber-100 dark:bg-amber-900/20 dark:text-slate-100 dark:ring-amber-800/50"
          : "bg-white/80 text-slate-700 ring-slate-200 hover:bg-slate-50 dark:bg-slate-900/70 dark:text-slate-200 dark:ring-slate-800 dark:hover:bg-slate-800",
      ].join(" ")}
      title={item.title}
    >
      <span
        className={[
          "flex h-11 w-11 shrink-0 items-center justify-center rounded-xl text-base transition",
          active
            ? "bg-white/15 text-white"
            : item.attention
            ? "bg-amber-100 text-amber-700 dark:bg-amber-900/40 dark:text-amber-200"
            : "bg-slate-100 text-slate-700 dark:bg-slate-800 dark:text-slate-200",
        ].join(" ")}
      >
        <Icon />
      </span>

      <span className="min-w-0 flex-1">
        <span className="block truncate font-bold font-montserrat">
          {item.title}
        </span>
        {item.subtitle && (
          <span
            className={[
              "mt-0.5 block truncate text-xs",
              active ? "text-white/75" : "text-slate-500 dark:text-slate-400",
            ].join(" ")}
          >
            {item.subtitle}
          </span>
        )}
      </span>

      <Badge value={item.badge} tone={item.badgeTone} />
    </button>
  );
}

export default function DashboardUserModuleNav({ items, activeId, onChange }) {
  return (
    <>
      <div className="lg:hidden -mx-2 overflow-x-auto px-2 no-scrollbar">
        <div className="flex gap-2 pb-2">
          {items.map((item) => {
            const Icon = item.icon;
            const active = activeId === item.id;

            return (
              <button
                key={item.id}
                type="button"
                onClick={() => onChange(item.id)}
                className={[
                  "inline-flex shrink-0 items-center gap-2 rounded-2xl px-3 py-2 text-sm ring-1 transition",
                  active
                    ? "bg-violet-600 text-white ring-violet-500"
                    : item.attention
                    ? "bg-amber-50 text-slate-800 ring-amber-200 dark:bg-amber-900/20 dark:text-slate-100 dark:ring-amber-800/50"
                    : "bg-white/80 text-slate-700 ring-slate-200 dark:bg-slate-900/70 dark:text-slate-200 dark:ring-slate-800",
                ].join(" ")}
              >
                <Icon />
                <span>{item.title}</span>
                <Badge value={item.badge} tone={item.badgeTone} />
              </button>
            );
          })}
        </div>
      </div>

      <aside className="hidden lg:block">
        <div className="sticky top-[100px] rounded-[28px] border border-slate-200 bg-white/80 p-2 shadow-sm backdrop-blur dark:border-slate-800 dark:bg-slate-900/70">
          <div className="mb-2 rounded-2xl bg-gradient-to-r from-[#013E8E] via-indigo-600 to-[#0f5cc0] px-4 py-4 text-white">
            <p className="text-xs font-bold uppercase tracking-[0.22em] text-white/70">
              Espace utilisateur
            </p>
            <p className="mt-1 font-bold font-montserrat">Mes informations</p>
          </div>

          <nav className="space-y-2">
            {items.map((item) => (
              <ModuleButton
                key={item.id}
                item={item}
                active={activeId === item.id}
                onClick={() => onChange(item.id)}
              />
            ))}
          </nav>
        </div>
      </aside>
    </>
  );
}